












































import { Component, Vue } from 'vue-property-decorator';
import { orderDetail } from '../../utils/api';
import card from './components_detailed/card.vue';
import consignee from './components_detailed/consignee.vue';
import remak from './components_detailed/remak.vue';
import payment from './components_detailed/payment.vue';
import invoice from './components_detailed/invoice.vue';
import explain from './components_detailed/explain.vue';
import product from './components_detailed/product.vue';
import information from './components_detailed/information.vue';
import noteInformation from './components_detailed/noteInformation.vue';
import { codeToChangeString } from './public_mdule/orderRes';
@Component({
  components: { card, consignee, explain, product, information, remak, payment, invoice },
})
export default class order_detailed_view extends Vue {
  orderId: string = '';
  detailInfo = {};
  dateTime: any = {
    hour: '',
    minute: '',
    second: '',
    day: '',
  };
  interval: any = null; //定时器
  $route: any;
  goBack() {
    this.$router.go(-1);
  }

  /*
   *@description:'补零操作'
   */
  resize(num) {
    return num < 10 ? `0${num}` : num;
  }

  /*
   *@description:'支付倒计时'
   */
  paymentCountdown(data) {
    console.log('paymentCountdown--', data); //day， hour minutes  second
    // expireTime   毫秒级
    let _day = data.day * 24 * 60 * 60;
    let _hour = data.hour * 60 * 60;
    let _minutes = data.minutes * 60;
    let lastTime = _day + _hour + _minutes + data.second;
    this.interval = setInterval(() => {
      if (lastTime > 1) {
        lastTime = lastTime - 1;
        let second = Math.floor(lastTime % 60); // 计算秒 ，取余
        let minite = Math.floor((lastTime / 60) % 60); //计算分 ，换算有多少分，取余，余出多少秒
        let hour = Math.floor((lastTime / 60 / 60) % 24); //计算小时，这里最长只有30min，用不着
        var day = Math.floor(lastTime / 60 / 60 / 24); //计算天，这里最长只有30min，用不着
        this.dateTime.day = this.resize(day);
        this.dateTime.hour = this.resize(hour);
        this.dateTime.minute = this.resize(minite);
        this.dateTime.second = this.resize(second);
      } else {
        console.log('else-------');
        //这里可以添加倒计时结束后需要执行的事件
        // alert("未在规定时间内支付，订单已失效！");
        // clearInterval(this.interval);
        //TODO 订单失效后的一些列操作：更改订单状态的同时回库存

        this.clearInterval();
      }
    }, 1000); //定时器 调度对象
  }
  clearInterval() {
    // console.log("清楚定时器");
    clearInterval(this.interval);
  }

  mounted() {
    this.orderId = this.$route.query.orderId;
    orderDetail(this.orderId).then((res) => {
      //改变字段，颜色
      codeToChangeString(res);
      this.detailInfo = res;
      if (res) {
        this.paymentCountdown(res);
      }
    });
  }
  get performanceOrderVOs() {
    return (this as any).detailInfo.performanceOrderVOs;
  }
}
